import {graphql} from 'react-relay';
import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation createDepartmentMutation($input: CreateDepartmentInput!) {
		createDepartment(input: $input) {
			department {
				node {
					...settingsDepartments_department
				}
			}
			company {
				allPersons(first: 10000, excludeClientUsers: true) {
					edges {
						node {
							id
							department {
								id
							}
						}
					}
				}
			}
		}
	}
`;

function getConfigs(companyId) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: companyId,
			connectionInfo: [
				{
					key: 'Company_departments',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'department',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Department Created');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				companyId: input.companyId,
				name: input.name,
				persons: input.persons,
			},
		},
		configs: getConfigs(input.companyId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
